export const DEFAULT_COUNTRY = "PER";

export const COUNTRIES = {
  ARG: "Argentina",
  BOL: "Bolivia",
  CHL: "Chile",
  COL: "Colombia",
  CRI: "Costa Rica",
  CUB: "Cuba",
  ECU: "Ecuador",
  ESP: "España",
  MEX: "México",
  PAN: "Panamá",
  PER: "Perú",
  PRY: "Paraguay",
  USA: "United States",
  URY: "Uruguay",
  VEN: "Venezuela",
};

export const LOCALES = {
  ARG: "es-AR",
  BOL: "es-BO",
  CHL: "es-CL",
  COL: "es-CO",
  CRI: "es-CR",
  CUB: "es-CU",
  ECU: "es-EC",
  ESP: "es-ES",
  MEX: "es-MX",
  PAN: "es-PA",
  PER: "es-PE",
  PRY: "es-PY",
  USA: "en-US",
  URY: "es-UY",
  VEN: "es-VE",
};

export const CURRENCIES = {
  ARG: "ARS",
  BOL: "BOB",
  CHL: "CLP",
  COL: "COP",
  CRI: "CRC",
  CUB: "CUC",
  ECU: "USD",
  ESP: "EUR",
  MEX: "MXN",
  PAN: "USD",
  PER: "PEN",
  PRY: "PYG",
  USA: "USD",
  URY: "UYU",
  VEN: "VEF",
};
